import React from "react";
import Banner from "../components/Banner";
import CardContainer from "../components/CardContainer";

const Home = () => {
  return (
    <div className="main">
      <Banner />
      <CardContainer />
    </div>
  );
};

export default Home;
